module.exports = __webpack_public_path__ + "assets/5de508774199084fcd71632da0523f98.svg";